/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FeedbackPopup from './FeedbackPopup';
import useAlert from '../../hooks/useAlert';
import styles from './LeadsHealthIssues.module.scss';
import { clickTracker } from '../../lib/common';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

const LeadsHealthIssues = ({ analysisData, projectId }) => {
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [selectedType, setSelectedType] = useState('');
  const [setAlert] = useAlert();
  const [authState] = useAuth();

  const handleReviewClick = async (key, data) => {
    setSelectedType(key);
    setPopupData(data?.popup || {});
    setShowFeedbackPopup(true);
    await clickTracker(`healthcheck_${key}`, 'leads_healthcheck');
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_${key}_update`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_leads`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
  };

  const handleCloseFeedbackPopup = () => {
    document.body.style.overflow = 'unset';
    setShowFeedbackPopup(false);
  };

  return (
    <div className="p-20">
      {analysisData && analysisData?.healthCheck === 90 ? (
        <div className="font12 fw500 color777 text-center pb-15">
          We have checked the following for your leads and everything looks good!
        </div>
      ) : (
        <>
          <div className="font12 fw500 color777 pb-15">
            {projectId === 'csportal'
              ? 'We found the following issues. You could be facing the problem of less leads/no leads/irrelevant leads due to them.'
              : 'We found the following issues. Your client could be facing the problem of less leads/no leads/irrelvant leads due to them.'}
          </div>
          <ul className={`${styles?.LeadsHealthIssues__list}`}>
            {analysisData &&
              Object.keys(analysisData).length > 0 &&
              Object.keys(analysisData).map(
                (eachKey) =>
                  eachKey &&
                  eachKey !== '' &&
                  analysisData[eachKey] &&
                  Object.keys(analysisData[eachKey]).length > 0 &&
                  Object.keys(analysisData[eachKey]).map((each, id) => (
                    <li
                      key={id}
                      className={`${styles.LeadsHealthIssues__item} ${
                        analysisData[eachKey]?.[each]?.hasIssue ? styles.LeadsHealthIssues__UpdateItem : ''
                      } whitefill_animate`}
                    >
                      <div className={`${styles.LeadsHealthIssues__imgbox}`}>
                        <img
                          alt="circle_keywords_icon"
                          className={`${styles.LeadsHealthIssues__img}`}
                          src={analysisData[eachKey]?.[each]?.display?.icon || ''}
                        />
                      </div>
                      <div className={`${styles.LeadsHealthIssues__txtbox} font12 fw500 color111`}>
                        {analysisData[eachKey]?.[each]?.display?.title || ''}
                      </div>
                      <div
                        role="button"
                        tabIndex={0}
                        onKeyDown={() => {}}
                        onClick={() => handleReviewClick(each, analysisData[eachKey]?.[each] || {})}
                        className={`${styles.LeadsHealthIssues__btnbox} ${
                          analysisData[eachKey]?.[each]?.hasIssue ? styles.redfill_animate : styles.bluefill_animate
                        } font10 fw500`}
                      >
                        Update
                      </div>
                    </li>
                  )),
              )}
          </ul>
        </>
      )}
      {showFeedbackPopup && (
        <FeedbackPopup
          popupData={popupData}
          handleCloseFeedbackPopup={handleCloseFeedbackPopup}
          id="contract"
          selectedType={selectedType}
          trackerId="healthcheck"
          setAlert={setAlert}
        />
      )}
    </div>
  );
};

export default LeadsHealthIssues;

LeadsHealthIssues.propTypes = {
  analysisData: PropTypes.object,
  projectId: PropTypes.string,
};
LeadsHealthIssues.defaultProps = {
  analysisData: {},
  projectId: '',
};
